import { PRICING_TEAM_EDITING_RIGHTS_EMAIL } from "../constants";

const removePricingTeamEmail = (str?: string) => {
  if (!str) {
    return str;
  }
  const emails = str.split(",");
  return emails
    .filter((email) => email !== PRICING_TEAM_EDITING_RIGHTS_EMAIL)
    .join(",");
};

export default removePricingTeamEmail;
